import React from 'react';
import laptopDevice from '../../assets/home/platform-laptop.png';
import phoneDevice from '../../assets/home/platform-phone.png';

// The two devices are supplied product renders with transparent backgrounds,
// cropped to their visible content so the page — not an invisible bounding
// box — controls the spacing around them. Laptop first and largest; the phone
// is its companion, standing on the same baseline.
const PlatformSection = () => (
  <section className="gh-section gh-platform">
    <div className="gh-section__inner">
      <span className="eyebrow">Digital platform</span>
      <h2 className="gh-section__title">The interface behind the infrastructure.</h2>
      <p className="gh-section__sub">
        Every meter reports into the GRIDx client portal — real-time consumption,
        remote load control and token top-ups, on desktop and mobile alike.
      </p>

      <div className="gh-platform__devices">
        <img
          className="gh-device gh-device--laptop"
          src={laptopDevice}
          width="1200"
          height="736"
          alt="GRIDx client portal dashboard on a laptop"
          loading="lazy"
          decoding="async"
        />
        <img
          className="gh-device gh-device--phone"
          src={phoneDevice}
          width="440"
          height="876"
          alt="GRIDx client portal on a mobile phone"
          loading="lazy"
          decoding="async"
        />
      </div>

      <ul className="gh-platform__points">
        <li>Real-time consumption tracking</li>
        <li>Remote load control</li>
        <li>Instant token top-ups</li>
        <li>Mobile and web access</li>
      </ul>
    </div>
  </section>
);

export default PlatformSection;
